import React from "react";
import Slider from "src/components/slider";
import Button from "src/components/button";

import { useMigrateSource } from "src/query/settings/dataSource";
import styles from "./styles.module.scss";

const MigrationSlider: React.FC<{
  show: boolean;
  onClose: () => void;
  item: any;
}> = ({ show, onClose, item }) => {

  const { mutate: migrateDataSource, isPending } = useMigrateSource();

  const handleConfirm = () => {
    if (item?.id) {
      migrateDataSource(item.id, {
        onSuccess: () => {
          onClose();
        }
      });
    }
  }

  return (
    <Slider.Dialog
      width="380"
      show={show}
      onClose={onClose}
      className={styles.container}
    >
      <Slider.Header title="migrate source" />
      <Slider.Body>
        <div className={styles.body}>
          <p className={styles.description}>
            This is a one-time activity that will let you migrate all your
            content at once into Paperflite. There are three pointers to know
            before you proceed:
          </p>

          <ul className={styles.migratePoints}>
            <li>
              The activity is timebound completely based on the number of assets
              in the source.
            </li>
            <li>
              This action is irreversible. Once you migrate, you cannot undo it.
            </li>
            <li>
              Once you proceed with migration, all the assets from the
              datasource will be migrated at once to Paperflite and the
              corresponding mappings created from this datasource will be
              deleted.
            </li>
          </ul>
        </div>
      </Slider.Body>
      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          variant="primary"
          onClick={handleConfirm}
          text={isPending ? "Confirming..." : "Confirm"}
          disabled={isPending}
        />
        <Button onClick={onClose} text="Cancel" />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default MigrationSlider;
